import styles from './FJRecording.module.less';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import classNames from 'classnames';
import { useRef, useEffect } from 'react';
import FJRotateIcon from '../../../../assets/svg/rotate-left.svg?react';
import PropTypes from 'prop-types';
import FJUtil from '../../../../util/FJUtil.js';
import FJEvent from '../../../../store/FJEvent.js';
import { FJ_EVENT_TYPE } from '../../../../constants/FJEvenTypeConstant.js';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip.jsx';
const FJRecording = props => {
    const { recorderDuration, onRetry, onStop, active, startRecord } = props;
    const waveRef = useRef(null);

    useEffect(() => {
        return FJEvent.subscribe(FJ_EVENT_TYPE.START_RECORDER, () => {
            waveRef.current.innerHTML = '';
            startRecord(waveRef.current);
        });
    }, []);

    const isStopDisabled = recorderDuration < 15;

    const _onStop = () => {
        if (isStopDisabled) {
            return;
        }
        onStop();
    };

    return (
        <div className={styles.box} style={{ display: active ? 'block' : 'none' }}>
            <div
                className={styles.record_desc}
                dangerouslySetInnerHTML={{
                    __html: FJLocalStore._('you-can-stop-after-15s-and-can-be-recorded-up-to-3min'),
                }}
            />
            <div className={classNames(styles.wave)} ref={waveRef} />
            <div className={styles.duration}>{FJUtil.formatTime(recorderDuration, undefined, 2)}</div>
            <div className={styles.btn_group}>
                <FJToolTip title='re-record'>
                    <div className={styles.retry_btn} onClick={onRetry}>
                        <FJRotateIcon />
                    </div>
                </FJToolTip>
                <FJToolTip title={isStopDisabled ? 'you-need-to-record-at-least-15s' : 'stop-recording'}>
                    <div
                        className={classNames(styles.stop_btn, isStopDisabled ? styles.disabled : '')}
                        onClick={_onStop}
                    />
                </FJToolTip>
            </div>
        </div>
    );
};

FJRecording.propTypes = {
    recorderDuration: PropTypes.number,
    onRetry: PropTypes.func,
    onStop: PropTypes.func,
    active: PropTypes.bool,
    startRecord: PropTypes.func,
};

export default FJRecording;
